import { lazy } from "react";
import type { RouteObject } from "react-router";
import { EXTERNAL_INVITATION_ROUTES } from "@/src/external-invitation/constants/external-invitation-routes";

const ExternalInvitationPage = lazy(() => import("../pages/external-invitation-page"));

export const externalInvitationRoutes: RouteObject = {
	path: EXTERNAL_INVITATION_ROUTES.ROOT,
	element: <ExternalInvitationPage />,
};
